import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';

export const queryParam = (name: string) => {
  const route = inject(ActivatedRoute);

  return toSignal(route.queryParams.pipe(
    map((query) => query[name] ? decodeURIComponent(query[name]) : undefined)
  ));
}
